import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import RatingIcon from "./RatingIcon.png";
import RatingGreyIcon from "./RatingWhiteIcon.png";
import ViewReviewInfo from "../../BookModule.module.css";
import { AxiosInstance } from "../../../../../../axios";
import Loader from "../../../../Loader";
import moment from "moment";

export default function ViewReview() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { RATING, APPROVALSTATUS, DATE } = location.state || [];
  const navigateToPreviousScreen = () => {
    navigate("/studyMaterials/Books/Reviews", {
      state: {
        filRating: RATING,
        filApproval: APPROVALSTATUS,
        filter_date: DATE,
      },
    });
  };

  useEffect(() => {
    if (id) {
      findbyid(id);
      window.scrollTo(0, 0);
    }

    const handleRefresh = () => {
      console.log("refreshPage event triggered");
      if (id) {
        findbyid(id);
        window.scrollTo(0, 0);
      }
    };

    window.addEventListener("refreshPage", handleRefresh);

    return () => {
      window.removeEventListener("refreshPage", handleRefresh);
    };
  }, [id]);

  const [isLoading, setIsLoading] = useState(false);
  const [fdata, setFdata] = useState({});

  const findbyid = (IDSS) => {
    if (!IDSS) return;

    setIsLoading(true);

    AxiosInstance.post("/api/book/review/viewById", {
      id: parseInt(IDSS),
    })
      .then((res) => {
        if (res.data.status && Array.isArray(res.data.data)) {
          const fiata = res.data.data[0];
          setFdata(fiata);
        } else {
          console.warn("Book data not found or empty response.");
          setFdata(null); // Clear old data if not found
        }
      })
      .catch((error) => {
        console.error("Error fetching book by ID:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const handleNavigateEdit = (id) => {
    navigate(`/studyMaterials/Books/Reviews/Edit/${id}`);
  };

  const handleNavigate = (setN, bookId, id) => {
    if (setN == 1) {
      navigate(`/studyMaterials/Books/ViewBookSet/${bookId}/${id}`, {
        state: {
          LABEL: "Back to View Review",
        },
      });
    } else {
      navigate(`/viewIndividualBook/${id}`, {
        state: {
          LABEL: "Back to View Review",
        },
      });
    }
  };

  const getYouTubeID = (url) => {
    if (!url || typeof url !== "string") return "";

    const regExp =
      /(?:youtube\.com\/(?:.*[?&]v=|v\/|embed\/|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : "";
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className="BathHeader global_container">
      <div className="row mx-0">
        <div className="col-md-6 col-12 px-0">
          <h2 className="TitleHeader">View Review</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={navigateToPreviousScreen}
                className="secondaryButton "
                variant="secondary"
              >
                Back to Reviews
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                onClick={() => handleNavigateEdit(id)}
                to={"javascript:void(0)"}
                className="primaryButton"
              >
                <span class="material-icons align-middle ">border_color</span>{" "}
                Edit Review Status
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="row mt-3 mb-3">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={ViewReviewInfo.preorderContainer}>
            <legend className="w-auto mb-0">Review Details</legend>
            <div className="row mx-0 mb-2">
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Book Name</p>
                  <p
                    onClick={() =>
                      handleNavigate(
                        fdata.is_set,
                        fdata.book_ids,
                        fdata.book_id
                      )
                    }
                    style={{ cursor: "pointer" }}
                    className={`confirm_value my-1 m-0 p-0 ${ViewReviewInfo.colorSkyBlue}`}
                  >
                    {fdata.book_title ? fdata.book_title : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">User Name</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {fdata.username ? fdata.username : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Email ID</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {fdata.email ? fdata.email : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Phone Number</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {fdata.phone_no ? fdata.phone_no : "_"}
                  </p>
                </div>
              </div>
            </div>

            <div className="row mx-0">
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Date</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {fdata.date ? moment(fdata.date).format("DD/MM/YYYY") : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex">
                    <p className="confirm_label m-0 p-0">Ratings</p>
                  </div>
                  <p className="confirm_value my-1 m-0 p-0">
                    {[...Array(5)].map((_, index) => (
                      <img
                        key={index}
                        className="ms-1"
                        src={index < fdata.rating ? RatingIcon : RatingGreyIcon} // Fill stars based on rating
                        alt={
                          index < fdata.rating
                            ? "Rating Icon"
                            : "Grey Rating Icon"
                        }
                      />
                    ))}
                  </p>
                </div>
              </div>
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex">
                    <p className="confirm_label m-0 p-0">Review Status</p>
                  </div>
                  <p className="confirm_value my-1 m-0 p-0">
                    {fdata.status == 0 && "Waiting For Approval"}
                    {fdata.status == 1 && "Approved"}
                    {fdata.status == 2 && "Rejected"}
                  </p>
                </div>
              </div>
            </div>
            {fdata.video_path && (
              <div className="px-0 col-lg-12 col-md-12 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex">
                    <p className="confirm_label m-0 p-0">YouTube URL</p>
                  </div>
                  <div className="my-1 col-lg-12 col-md-12 col-12 pt-3 text-center">
                    <iframe
                      src={`https://www.youtube.com/embed/${getYouTubeID(
                        fdata.video_path
                      )}`}
                      className={`${ViewReviewInfo.iframeVideo}`}
                      allowFullScreen
                      title="Dynamic Iframe"
                    ></iframe>
                  </div>
                </div>
              </div>
            )}

            <div className="row mx-0">
              <div className="px-0  col-lg-12 col-md-12 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Review</p>
                  <p className="confirm_value text-justify my-1 m-0 p-0">
                    {fdata.review ? fdata.review : "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
}
